import styles from './FactorModal.module.scss';
import { Mask } from 'antd-mobile';
import SwipeContainer from '@/components/Mobile/Swipe';
import { inject, observer } from 'mobx-react';
import { Storage } from '@/utils/Storage';
const FactorModal = (props) => {
    const { simulation } = props.store;
    const onSwipeLeft = () => {
        if (props.setShowFactorModal) {
            props.setShowFactorModal(false);
            Storage.set(simulation.factorStorageName, true);
        }
    };
    return (
        <>
            <Mask visible={props.visible}>
                <div className={styles.modalWrap}>
                    <SwipeContainer onSwipeLeft={onSwipeLeft}>
                        <div className={styles.imgWrap}>
                            {new Array(11).fill(0).map((item, index) => (
                                <img key={index} src={require(`@/assets/images/mobile/simulation/${index + 1}.svg`)} alt="" />
                            ))}
                        </div>
                    </SwipeContainer>
                    <div className={styles.textDescription}>左右滑动查看案例背景</div>
                </div>
            </Mask>
        </>
    );
};

export default inject('store')(observer(FactorModal));
